// extracted by mini-css-extract-plugin
module.exports = {"inner_content_wrapper":"InnerContentWrapper_inner_content_wrapper__3Ny_d","full_width":"InnerContentWrapper_full_width__2NlMF"};